export default {
      id: "ic_newsletters-usage",
      viewBox: "0 0 60 60",
      url: "../dist/images/" + "sprite.svg#ic_newsletters-usage",
      toString: function () {
        return this.url;
      }
    }